module.exports = __webpack_public_path__ + "img/beslagkom-met-droge-ingredienten.99ac5d01.jpg";